import React from 'react';
import StandalonePage from '../../../Elements/StandalonePage';
import MessageCard from '../../../Elements/MessageCard';

function StandalonePageDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Bounded preview — the real shell fills the viewport (min-height 100vh)</div>
      </div>
      <div className='dsg-row'>
        {/* .dsg-standalone caps the 100vh shell so it fits the gallery pane. */}
        <StandalonePage className='dsg-standalone'>
          <MessageCard title='Whatever the page has to say'>
            <p className='mcard-text'>
              The shell only centres the brand lockup over its children — the content is usually a Message card (see the
              Cards section).
            </p>
          </MessageCard>
        </StandalonePage>
      </div>
    </div>
  );
}

export const standalonePageDemo = {
  id: 'standalone-page',
  title: 'Standalone page (outside the app shell)',
  category: 'Navigation & Layout',
  importPath: 'Elements/StandalonePage',
  notes: [
    'For a page rendered OUTSIDE the app shell — no sidebar, no header, no logged-in user: sign-in blocked, maintenance, session expired. Inside the shell use the normal page header instead (content.js / .page-head).',
    'Fills the viewport and centres a BravoLogo brand lockup over its children. Props: children, wordmark (default "Bravo"), className.',
    'It already carries .bravo-ds, so DS component classes work inside it without a further opt-in.',
    'The content is normally a Message card — see that entry under Cards for the card itself.',
    'First used by Elements/SignInUnavailable.tsx (CD-5515).',
  ],
  snippet:
    "<StandalonePage>\n  <MessageCard eyebrow='Bravo access' title='Sign-in unavailable' iconName='fa-solid fa-lock' actions={actions}>\n    ...\n  </MessageCard>\n</StandalonePage>",
  render: StandalonePageDemoComponent,
};
